// extracted by mini-css-extract-plugin
export default {"dFlex":"Tree_dFlex__IvFq0","link":"Tree_link__-GGkE"};